// Рекурсивная функция для глубокого мерджа полей объектов Target из полей объекта Source
export const deepMerge = <T>(target: T, source: any): T => {
  if (!source || typeof source !== 'object') return target;

  const result = { ...target } as any;

  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      const sourceValue = source[key];
      const targetValue = result[key];

      // Если значение null или undefined - удаляем поле
      if (sourceValue === null || sourceValue === undefined) {
        delete result[key];
      }
      // Если массив - заменяем целиком
      else if (Array.isArray(sourceValue)) {
        result[key] = sourceValue;
      }
      // Если оба значения - объекты (не массивы), мерджим рекурсивно
      else if (
        sourceValue instanceof Object &&
        targetValue instanceof Object &&
        !Array.isArray(targetValue)
      ) {
        result[key] = deepMerge(targetValue, sourceValue);
      } else {
        // Для примитивов или разных типов - заменяем
        result[key] = sourceValue;
      }
    }
  }

  return result as T;
};
